import { Mountain } from "lucide-react";

export default function CantalBadge({ size = "sm", testId = "cantal-badge" }) {
  const big = size === "lg";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full bg-[#2BA6A4]/10 text-[#1E7E7C] border border-[#2BA6A4]/30 ${big ? "px-4 py-2 text-sm" : "px-2.5 py-1 text-[11px]"}`}
      data-testid={testId}
    >
      <Mountain size={big ? 16 : 12} strokeWidth={2} />
      Fait main dans le Cantal
    </span>
  );
}
